import React from 'react'
import { Alert } from 'react-bootstrap'
import { ShowIf } from '@ztechapps/webui.util'
import type { ProductCurrentInventory } from '@ztechapps/common.contract'
import { ProductTypeEnum } from '@ztechapps/common.contract'
import { useContext } from './Context'

type OutOfStockWarningProps = {
  inventory?: ProductCurrentInventory
  productType?: ProductTypeEnum
  requiredComputedQuantityOnHand?: number
  quantity?: number
}
export const OutOfStockWarning = ({
  inventory,
  productType,
  requiredComputedQuantityOnHand,
  quantity,
}: OutOfStockWarningProps) => {
  const { document: order } = useContext()

  const canOrder =
    (inventory?.quantityOnHand ?? 0) + (requiredComputedQuantityOnHand ?? 0) >= (quantity ?? 0) ||
    order?.allowPrePayment ||
    productType !== ProductTypeEnum.Inventory
  return (
    <ShowIf condition={!canOrder}>
      <div className="mt-2">
        <Alert variant="warning">
          <small>
            This is not our stock item, but we can easily build it for you. Click the &quot;Message Us!&quot; button
            below and we will inform you when it will be available.
          </small>
        </Alert>
      </div>
    </ShowIf>
  )
}
